module.exports = __webpack_public_path__ + "static/media/photo-1.aef74485.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/long-road-student-centre/photo-1.jpg
// module id = 163
// module chunks = 0